import { gql } from "@apollo/client";

//export const customerStatusOption = ["ACTIVE", "BLOCKED"];
export const customerStatusOption = ["YET TO VISIT", "VISITED"];

export const getAllCustomermasterDropdown = gql`
  query GetAllCustomerMasterDropdown($search: String) {
    getAllCustomermasterDropdown(search: $search) {
      success
      message
      data {
        id
        customerName
        customerCode
      }
    }
  }
`;

export const allCustomers = gql`
  query {
    allCustomers {
      id
      customerName
      customerCode
      customerCategory
      priceCode
      repName
      repCode
      creditlimit
      creditperiod
      balance
      customerStatus
      status
      createdAt
    }
  }
`;

export const getCustomermasterByCode = gql`
  query GetCustomerByCode($code: String!) {
    getCustomermasterByCode(code: $code) {
      success
      error
      message
      data {
        id
        customerCode
        customerName
        customerCategory
        status
        creditLimit
        creditPeriod
        addresses {
          id
          address
          latitude
          longitude
        }
      }
    }
  }
`;

export const getByIdCustomer = gql`
  query GetCustomer($id: ID!) {
    getCustomer(id: $id) {
      id
      customerName
      customerCode
      customerCategory
      priceCode
      repName
      repCode
      creditlimit
      creditperiod
      balance
      customerStatus
      status
      createdAt
    }
  }
`;

export const todayCustomers = gql`
  query TodayCustomers($page: Int, $pageSize: Int, $search: String) {
    todayCustomers(page: $page, pageSize: $pageSize, search: $search) {
      success
      message
      totalCount
      customers {
        id
        customerName
        customerCode
        customerCategory
        priceCode
        repName
        repCode
        creditlimit
        creditperiod
        balance
        customerStatus
        status
        createdAt
        lastUpdate
        user {
          employeeName
        }
      }
    }
  }
`;

export const pastCustomers = gql`
  query PastCustomers($page: Int, $pageSize: Int, $search: String) {
    pastCustomers(page: $page, pageSize: $pageSize, search: $search) {
      success
      message
      totalCount
      totalPages
      currentPage
      hasNextPage
      customers {
        id
        customerName
        customerCode
        customerCategory
        priceCode
        repName
        repCode
        creditlimit
        creditperiod
        balance
        customerStatus
        status
        createdAt
        lastUpdate
          user {
          employeeName
        }
      }
    }
  }
`;

export const createCustomer = gql`
  mutation CreateCustomer($input: CustomerInput!) {
    createCustomer(input: $input) {
      success
      error
      message
    }
  }
`;

export const updateCustomerList = gql`
  mutation UpdateCustomer($input: UpdateCustomerInput!) {
    updateCustomerList(input: $input) {
      success
      error
      message
    }
  }
`;

export const uploadCustomerList = gql`
  mutation UploadCustomers($file: Upload!, $userId: Int!) {
    uploadCustomerList(file: $file, userId: $userId) {
      success

      message
    }
  }
`;

export const customerVisitHistory = gql`
  query customerVisitHistory($customerid: ID!) {
    customerVisitHistory(customerId: $customerid) {
      employeeName
      employeeCode
      checkInTime
      checkOutTime
      duration
      checkinLat
      checkinLng
      checkoutLat
      checkoutLng
      remarks
      orderNumber
      orderType
      visitDate
      status
    }
  }
`;

export const exportAllPastVisits = gql`
  mutation {
    exportAllPastVisits {
      success
      fileUrl
      message
    }
  }
`;

export const customerStatusSelect = [
  {
    value: "ACTIVE",
    label: "Active",
  },
  {
    value: "BLOCKED",
    label: "Block",
  },
];

export const GetVisitCustomerById = gql`
  query GetCustomerById($id: ID!) {
    getCustomer(id: $id) {
      success
      message
      totalCount
      currentPage
      totalPages
      hasNextPage
      hasPreviousPage
      customers {
        id
        customerName
        customerCode
        customerCategory
        priceCode
        repName
        repCode
        creditlimit
        creditperiod
        balance
        customerStatus
        status
        createdAt
        lastUpdate
        salespersonvisitckoutSet {
          remarks
        }
      }
    }
  }
`;
